import React, { useContext, useEffect, useMemo, useState } from "react";
import { useForm } from "react-hook-form";
import { Select, MenuItem, FormControl, FormControlLabel, RadioGroup, Radio, Typography } from "@mui/material";
import { useSnackbar } from "notistack";
import ButtonTheme from "../../ThemeButton/ThemeButton";
import ApiService from "../../../functions/apiService";
import { toast } from 'react-toastify';

export default function DeleteLocks() {
    // const { enqueueSnackbar } = useSnackbar();
    const [loading, setLoading] = useState(false);
    const onSubmit = () => {
        setLoading(true)
        ApiService.post('/postUserLock', {
            allUser: true,
            userId: 'all',
            action: 'delete',
            type: 'all',
            function: 'TEMPORARY_HOLD'
        })
            .then(({ data }) => {
                setLoading(false);
                toast.success('Success')
                // enqueueSnackbar('success', { variant: 'success' });
            }).catch(({ data }) => {
                setLoading(false);
                toast.error('Error')
                // enqueueSnackbar('Error', { variant: 'error' });
            });
    }
    return <>
        <Typography fontWeight='700' fontSize="16px">Delete Locks</Typography>


        <div className="col-12 mt-2">
            <ButtonTheme disabled={loading} onClick={onSubmit} color='primary'>Delete Temp Holds</ButtonTheme>
        </div>

    </>
}
